"use client";

import * as config from "@/app/config";
import { initDatadog } from "@medimo/monitor";

if (config.IS_DATADOG_ENABLED) {
  initDatadog(
    config.APPLICATION_ID,
    config.CLIENT_TOKEN,
    config.RUM_ENV,
    config.API_URL,
    config.NEXT_PUBLIC_DATADOG_ENDPOINT,
  );
}
export const DatadogInit = () => {
  return null;
};
